import React, { FC } from 'react'
import RadioButtonGroup from '../../common/components/RadioButtonGroup'
import RadioButton from '../../common/components/RadioButton'
import { type SearchType } from '../types'
import { useSearch } from '../hooks'
import { useAppSelector } from '../../hooks'
import { selectLastSearchedType } from '../searchSlice'


const ParcelSearchInput: FC = () => {
  const [{ mode, isSearching, query }, { changeMode, onChange, search, onKeyUp }] = useSearch()
  const lastSearchedType = useAppSelector(selectLastSearchedType);


  const btnSearchClasses = `fa ${isSearching ? "fa-spinner fa-spin" : "fa-search"}`
  return (
    <>
      <h4>{mode === null ? "Choose a Search Method" : "Enter Your Search"}</h4>
      <div className="control-group">
        <RadioButtonGroup<SearchType> onChange={changeMode} value={lastSearchedType || "Address"}>
          <RadioButton<SearchType> value="Address" label="Address" />
          <RadioButton<SearchType> value="Owner" label="Owner" />
          <RadioButton<SearchType> value="PIN" label="PIN" />
          <RadioButton<SearchType> value="TMS" label="TMS" />
        </RadioButtonGroup>
      </div>
      <div id="searchBox" className={mode === null ? "waiting" : ""}>
        <span id="btnSearch" className={btnSearchClasses} onClick={search}></span>
        <input id="txtSearch" type="text" placeholder="Enter text & press 'Enter'" autoComplete="off" value={query} onChange={onChange} onKeyUp={onKeyUp} disabled={mode === null} />
      </div>
    </>
  )
}

export default ParcelSearchInput